import {createAction} from '@reduxjs/toolkit';

import {UserAddress} from 'types';

export const fetchUserAddressesAction = createAction('FETCH_USER_ADDRESSES');

export const setUserAddressesAction = createAction<UserAddress[]>('SET_USER_ADDRESSES');

export const setSelectedAddressAction = createAction<UserAddress | undefined>('SET_SELECTED_ADDRESS');

export const updateBasketAddressAction = createAction('UPDATE_BASKET_ADDRESS');
